export default "__VITE_ASSET__BLoxvqGP__"